var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13246_45900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0V21.3334H21.3334V31.9996H0.00025V21.3333H0V10.6665H10.6666V0H32Z",
    fill: "#9DD6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.9994H10.6666V21.3328H0V31.9994Z",
    fill: "#3F72AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 21.3334H32.0004V10.6664H21.3337V21.3334ZM10.667 10.6666H21.3337V0H10.667V10.6666Z",
    fill: "#00A9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.667 21.333H21.3337V10.6663H10.667V21.333Z",
    fill: "#2191C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.333 10.6666H31.9996V0H21.333V10.6666Z",
    fill: "#3F72AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13246_45900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendGrid);
export default __webpack_public_path__ + "static/media/SendGrid.6b258819d0b97067b5842401941c01f8.svg";
export { ForwardRef as ReactComponent };